module.exports = __webpack_public_path__ + "img/sinBarrreras245.56003a47.jpg";